import type { CaseStudySection } from './amexCaseStudy';

export const hotelplannerIntro = {
  client: 'HotelPlanner',
  title: 'Redesigning an online booking experience with $1B annual volume',
  summary:
    'Led a mobile-first redesign of a hotel landing page with $1B+ in annual transaction volume, grounded in competitive analysis of leading travel sites.',
  background: 'linear-gradient(180deg, #E8F0F6 0%, #B8CCDC 100%)',
};

export const hotelplannerDesktopVideo =
  'https://cdn.magicpatterns.com/uploads/7rbdvdbUgZbQ9AzqtRNEes/hp%20hotel%20page%20desktop.mp4';

export const hotelplannerMetrics = [
  { value: '$1B+', label: 'annual transaction volume' },
  { value: '2M', label: 'monthly visitors' },
  { value: '2,500+', label: 'event planners on companion SaaS' },
];

export const hotelplannerSections: CaseStudySection[] = [
  {
    heading: 'A dated experience at the moment of purchase',
    paragraphs: [
      "HotelPlanner is a large online travel agency. Its booking experience looked old and didn't work well on phones, which cost trust right where it mattered most, at the point of conversion. A cleaner, easier flow was the most direct way to win back conversions that competitors were capturing.",
    ],
  },
  {
    heading: 'Too much data for a small screen',
    paragraphs: [
      'Each hotel came with a huge amount of data, and I had to fit it onto a phone screen. The existing UI had been designed by developers and was overloaded with information.',
    ],
  },
  {
    heading: 'Key design decisions',
    bullets: [
      "I designed mobile first, since it's the most-used form factor. The small screen forced me to prioritize ruthlessly.",
      'I showed users only the highlights and used progressive disclosure for the rest. The main page carries just enough to scan and compare, and modals hold the details.',
      'I borrowed proven patterns from competitors. Many companies have already worked on this problem, so I used their best practices to reach parity quickly rather than reinventing anything.',
    ],
  },
  {
    heading: 'Starting from the end state',
    paragraphs: [
      'Rather than build up gradually, I started with a mobile-optimized experience that already reflected competitor best practices. That gave the team something concrete to react to.',
    ],
  },
  {
    heading: 'Prototype and results',
    paragraphs: [
      'I built a full prototype in Figma at desktop and mobile sizes, and later rebuilt it in Magic Patterns. The new design produced an immediate, visible lift in conversion. Channel partners responded positively, and the company has kept using the designs.',
    ],
  },
];
